import React, { useState } from "react";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
// import useUsers from "../../../hooks/use-users";

import { DataGrid, Icon } from "../../../components";
import { CustomButton, CustomDialog, CustomSelect, FeaturedIcon, FormElement, FormikTextField, MultiSelect } from "../../../components";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import css from "./modals.module.css";
import RebatesClient from "../../../RebatesClient";
import { useMutation } from "../../../hooks/use-mutation";
import { IconButton } from "@mui/material";
import ModalUserRemove from "./modal-user-remove";

const ModalUser = ({
  open,
  onClose,
  user,
  userConfigType,
  onRemoveUser,
  account
}) => {

  const [showUserRemoveModal, setShowUserRemoveModal] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  // console.log(account)
  const validationSchema = Yup.object({
    first_name: Yup.string().required("First name is required"),
    last_name: Yup.string().required("Last name is required"),
    email: Yup.string()
      .required("Email is required")
      .email("Enter a valid email address"),
  });

  const isCreatingUser = !user?.id;

  const { mutateAsync: submitRequest, isLoading, } = useMutation({
    mutationKey: "saveUser",
    networkMode: "always",
    mutationFn: async (updatedData) => RebatesClient.saveUser(updatedData),
    onError: (err) => { console.log(err) },
    onSuccess: (resp) => {
      if (resp.response.status == 200) {
        if (isCreatingUser && account?.id) {
          if (resp.body?.emailSent === true) {
            alert("User account was created and the welcome email has been sent.");
          } else if (resp.body?.emailSent === false) {
            alert(
              "User account was created, but the welcome email could not be sent. Open the user and use Send Welcome Email to retry."
            );
          } else {
            alert("User account was created.");
          }
        }
        close()
      }
      else {
        alert(`${resp.body.status}`)
      }

    }
  });

  const { mutateAsync: sendWelcomeEmail, isLoading: isSendingWelcomeEmail } = useMutation({
    mutationKey: "sendWelcomeEmail",
    networkMode: "always",
    mutationFn: async (userId) => RebatesClient.sendWelcomeEmail(user?.id, account?.id),
    onError: (err) => { console.log(err) },
    onSuccess: (resp) => {
      if (resp.response.status == 200) {
        // close()
      }
      else {
        alert(`${resp.body.status}`)
      }

    }
  });


  function close() {
    formik.resetForm()
    setShowUserRemoveModal(false)
    onClose()
  }


  //for now if configuring valley users only allow val rep or finance
  const userRoles = [
    { id: "VALMONT_REP", name: "Valmont Rep", value: "VALMONT_REP" },
    { id: "VALMONT_FINANCE", name: "Valmont Finance", value: "VALMONT_FINANCE" },
    // {id: "SUPER_ADMIN", name: "Super Admin", value: "SUPER_ADMIN"},
    // {id: "FARM", name: "Farm", value: "FARM"},
    // {id: "STRATEGIC_ACCOUNT", name: "Strategic Account", value: "STRATEGIC_ACCOUNT"},

  ];

  const formik = useFormik({
    initialValues: {
      id: user?.id || null,
      ...(account ? { account_id: account?.id } : {}),
      user_role: user?.user_role || null, //user role gets set coming in or gets ovrrriden if setting valley user role
      first_name: user?.first_name || "",
      last_name: user?.last_name || "",
      email: user?.email || "",
    },

    validationSchema: validationSchema,

    onSubmit: submitRequest
  });


  const title = (
    <div className={css.modalTitle}>
      <FeaturedIcon icon="User" />
      {user?.id ? 'Edit' : 'New'} {userConfigType} User
    </div>
  );


  return (

    <>


      <CustomDialog open={showUserRemoveModal ? false : open} onClose={onClose} width={640} title={title}>

        <FormikProvider value={formik}>
          <Form className={css.modalForm}>

            <FormikTextField
              label="First Name"
              labelShrink={true}
              name="first_name"
              type="text"
              halfWidth />

            <FormikTextField
              label="Last Name"
              labelShrink={true}
              name="last_name"
              type="text"
              halfWidth />

            <FormikTextField
              label="Email"
              labelShrink={true}
              name="email"
              type="email"
              halfWidth
              onChange={(e) => {
                const value = e.target.value || "";
                formik.setFieldValue('email', value.toLowerCase());
              }} />

            {user?.id && (
              <div style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
              }}>

                <Button
                  fullWidth
                  variant="outlined" color="primary"

                  style={{
                    height: 44,
                    textTransform: "none",
                    fontFamily: 'Inter',
                    color: "primary",
                    borderColor: "primary",
                  }}
                  disabled={formik.dirty || emailSent}
                  onClick={() => {setEmailSent(true); sendWelcomeEmail() }}
                >
                  {emailSent ? 'Email Sent' : user?.password_email_req_sent ? 'Resend Welcome Email' : 'Send Welcome Email'}
                  <SendIcon style={{ marginLeft: 20 }} />
                </Button>

              </div>
            )}

            {userConfigType == "Valley" &&
              <CustomSelect
                label='User Type*'
                name="user_role"
                value={formik.values.user_role}
                onChange={formik.handleChange}
                options={userRoles}
                halfWidth
              />
            }

            <div className={css.actions}>
              {user?.id && <div>
                <IconButton onClick={() => setShowUserRemoveModal(true)}>
                  <Icon icon="Trash" />
                </IconButton>
              </div>
              }

              <CustomButton
                label="Cancel"
                onClick={onClose}
                color="secondary" />

              <CustomButton
                label="Save"
                type="submit"
                color="primary"
                onSubmit={formik.handleSubmit}
                disabled={!formik.dirty}
              />


            </div>
          </Form>
        </FormikProvider>
      </CustomDialog>

      <ModalUserRemove
        open={showUserRemoveModal}
        activeUser={user}
        account={account}
        onDeleteComplete={() => {
          close()
        }}
        onClose={() => {
          //don't call modal-user on close beacuse we just want to close the remove modal
          setShowUserRemoveModal(false);
        }
        } />
    </>
  );
};

export default ModalUser;
